import React from 'react';
import s from '../Settings/SettingsBlock.module.css';
import cs from './AmountAndUnit.module.css';
import { Amount } from './Amount';
import { Unit } from './Unit';

export function AmountAndUnit({ amountValue, unitValue, labelText, inventoryGuid, hasFullAccess, warehouseId, setNewInventoryLog, updateCost }) {
    return (
        <div className={s.amountAndUnit}>
            <label>
                <span className={s.title}>{labelText}</span>
                <div className={cs.amountAndUnitWrapper}>
                    <Amount
                        value={amountValue}
                        setNewInventoryLog={setNewInventoryLog}
                        inventoryGuid={inventoryGuid}
                        hasFullAccess={hasFullAccess}
                        warehouseId={warehouseId}
                        updateCost={updateCost}
                    />
                    <Unit
                        value={unitValue}
                        inventoryGuid={inventoryGuid}
                        hasFullAccess={hasFullAccess}
                    />
                </div>
            </label>
        </div>
    );
}
